// covered-by: frontends/carrie/src/routes/ask-puntt/components/canvas/blocks/__tests__/AssetDownloadButton.test.tsx
import { type ReactNode, useState } from "react";

import { downloadAsset } from "../../../../../utils/http";

/**
 * Download a gated `static.puntt.ai` (or other) asset via fetch so the
 * service worker can inject Authorization. A raw `<a href target="_blank">`
 * navigates in a new tab without that header and AssetShield returns
 * Access Denied — the right-pane download path already uses downloadAsset.
 */
export function AssetDownloadButton({
  url,
  fileName,
  testId,
  ariaLabel,
  className,
  title,
  children,
}: {
  url: string;
  fileName: string;
  testId: string;
  ariaLabel: string;
  className?: string;
  title?: string;
  children: (state: { downloading: boolean }) => ReactNode;
}) {
  const [downloading, setDownloading] = useState(false);

  const handleClick = async () => {
    if (downloading || !url) return;
    setDownloading(true);
    try {
      await downloadAsset(url, fileName);
    } catch (err) {
      console.error("Failed to download gated asset", err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={downloading || !url}
      data-testid={testId}
      aria-label={ariaLabel}
      title={title}
      className={className}
    >
      {children({ downloading })}
    </button>
  );
}
